<div class="small-padding small-margin form-card-section" (click)="clickCard()" style="width: 100%">
  <div class="small-padding secondary-border form-card-border-top">
    <div class="uk-margin-small-left uk-margin-small-right">
      {{ formation.libelle }}
    </div>
  </div>
  <!-- border LTR > main color | no border B | bonus biseau -->
  <div class="form-card-border-bot">
    <!-- border LBR > secondary color ? | no border T -->
    <div class="small-padding align-left form-card-middle-limit">
      <!-- sur une même ligne | background-color = couleur secondaire ? -->
      <div class="float-right k-icon icon-base-height uk-margin-small-right" *ngFor="let modalite of formation.modalite" [ngClass]="getModalityIcon(modalite)"></div>
      <div class="uk-margin-small-left">{{ formation.duree }} JOUR{{ formation.duree > 1 ? 'S' : '' }}</div>
    </div>
    <div class="uk-margin-small-left small-padding">{{ formation.description }}</div>
    <div class="align-center uk-margin-bottom" ng-show="formation.nbSessions">
      <b>{{ formation.nbSessions }} sessions disponibles</b>
    </div>
  </div>
</div>
